import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthContext = createContext({ user: null, loading: true, refresh: () => {}, logout: async () => {} });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      // httpOnly session cookie is the only source of truth.
      const r = await axios.get(`${API}/auth/me`, { withCredentials: true });
      setUser(r.data);
      return r.data;
    } catch {
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch (e) {
      // eslint-disable-next-line no-console
      // eslint-disable-next-line no-console
      console.warn("Logout API failed:", e?.message || e);
    }
    setUser(null);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const value = useMemo(() => ({ user, loading, refresh, logout }), [user, loading, refresh, logout]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);

export const startGoogleLogin = (redirectPath = "/auth/callback") => {
  const target = `${window.location.origin}${redirectPath}`;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(target)}`;
};
